// This is here as a way to allow a globally available premade controller
// to the mini modal dialog to bind data without creating an anonymous inline
// controller in each use case
export class MwMiniModalDialogController {
    constructor() {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/dialog/mini-modal/mini-modal.dialog.controller.ts